module.exports = __webpack_public_path__ + "static/media/icn_diamond_point_merge.dd196077.svg";